// extracted by mini-css-extract-plugin
export default {"fs":"a097347d3d _9677ad37f9"};